// extracted by mini-css-extract-plugin
module.exports = {"vibeProductCard":"VibeSection_vibeProductCard__6ElVW","compactVibeTabs":"VibeSection_compactVibeTabs__N07V5"};